
<!--
  ~ VNCmail : A whole new experience in enterprise email communication.
  ~ Copyright (C) 2015-2020 VNC – Virtual Network Consult AG (info@vnc.biz)
  ~
  ~ This program is free software: you can redistribute it and/or modify
  ~ it under the terms of the GNU Affero General Public License as published by
  ~ the Free Software Foundation, version 3 of the License.
  ~
  ~ This program is distributed in the hope that it will be useful,
  ~ but WITHOUT ANY WARRANTY; without even the implied warranty of
  ~ MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
  ~ GNU Affero General Public License for more details.
  ~
  ~ You should have received a copy of the GNU Affero General Public License
  ~ along with this program. Look for COPYING file in the top folder.
  ~ If not, see http://www.gnu.org/licenses/.
  -->

<div class="searchfolder-header disable-select" *ngIf="!routeUrl.startsWith('/contacts')">
    <span class="subfolder-title">{{ 'SAVED_SEARCH' | translate }}</span>
    <div class="folder-action" id="folder-action">
        <span class="action-icons" (click)="expandCollapseUserRootFolder(true);expandEvent.emit(true)" *ngIf="!isRootUserFolderCollapsed" matTooltip="{{'COLLAPSE' | translate}}"><ng-container [ngTemplateOutlet]="collapseIcon"></ng-container></span>
        <span class="action-icons" (click)="expandCollapseUserRootFolder(false);expandEvent.emit(false)" *ngIf="isRootUserFolderCollapsed" matTooltip="{{'EXPAND' | translate }}"><ng-container [ngTemplateOutlet]="expandIcon"></ng-container></span>
    </div>
</div>
<mat-divider class="sidebar-mat-divider"></mat-divider>

<div class="sidebar-item" *ngIf="routeUrl.startsWith('/contacts')">
    <div class="item-icon" id="folder-action">
      <mdl-icon *ngIf= "isRootUserFolderCollapsed" (click)="expandCollapseUserRootFolder(false)">expand_more</mdl-icon>
      <mdl-icon *ngIf= "!isRootUserFolderCollapsed" (click)="expandCollapseUserRootFolder(true)">expand_less</mdl-icon>
    </div>
    <div class="item-title">{{'SAVED_SEARCH'| translate}}</div>
</div>
<cdk-virtual-scroll-viewport *ngIf="folders" itemSize="20" [ngStyle]="{ 'max-height': getMaxHeight(), 'display': !isRootUserFolderCollapsed ? 'block' : 'none'}" class="user-search-folders-viewport">
    <ng-container *cdkVirtualFor="let item of folders"></ng-container>
    <mat-tree [dataSource]="dataSource" [treeControl]="treeControl" class="sidebar-tree-subfolders">
        <mat-tree-node *matTreeNodeDef="let node" matTreeNodeToggle matTreeNodePadding style="white-space:no-wrap;"
            [contextMenu]="searchFolderMenu" (contextmenu)="onContextMenu($event, node)"
            class="sub_folder_tree_node">
            <li *ngIf="node" class="sub_folder">
                <div class="mat-tree-node" cdkDropList
                    [class.selected-class]="selectedFolder && node.id === selectedFolder.id">
                    <button mat-icon-button disabled></button>
                    <div class="folder-information">
                        <div (click)="openAdvanceSearch(node)" class="folder-div disable-select">
                            <span style="height: 22px;">
                                <ng-container [ngTemplateOutlet]="folderIcon"></ng-container>
                            </span>
                            <span class="sidebar-title"
                                [ngClass]="{'broken-share-folder': node.owner && !node.oname}">
                                {{node.name}}</span>
                        </div>
                        <div class="folder-information-preview" *cdkDragPreview>
                            <mat-icon [style.color]="node.rgb">folder</mat-icon>
                            <span class="sidebar-title"
                                [ngClass]="{'broken-share-folder': node.owner && !node.oname}">
                                {{node.name}}</span>
                        </div>
                    </div>
                </div>
            </li>
        </mat-tree-node>
    </mat-tree>
</cdk-virtual-scroll-viewport>
<context-menu #searchFolderMenu id="smartSearchMenu">
    <ng-template contextMenuItem (execute)="deleteSmartSearch($event)">
      <div class="context-item" [ngClass]="{ 'carbon-theme': (currentTheme == 'carbon' && !isFluid) }">
          <mat-icon>delete</mat-icon>
          <span>{{ 'DELETE' | translate }}</span>
      </div>
    </ng-template>
    <!-- <ng-template contextMenuItem (execute)="renameSmartSearch($event)">
      <div class="context-item">
          <mat-icon>edit</mat-icon>
          <span>{{ 'RENAME_SEARCH' | translate }}</span>
      </div>
    </ng-template> -->
  </context-menu>

<ng-template #folderIcon>
<svg width="20px" height="20px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <g id="Icon/product/folder-new" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="Icon-24px" transform="translate(2.000000, 4.000000)" fill="#8B96A0">
            <path d="M7.00922203,0 C7.49995184,0 8.18025928,0.262988878 8.59481703,0.605726148 L8.71075654,0.71075654 L9.28924346,1.28924346 C9.65129486,1.65129486 10.3113868,1.94247309 10.8421188,1.99242242 L10.9970301,2 L18,2 C19.05,2 19.9177686,2.82004132 19.9944872,3.85130541 L20,4 L20,14 C20,15.05 19.1799587,15.9177686 18.1486946,15.9944872 L18,16 L2,16 C0.95,16 0.082231405,15.1799587 0.00551277235,14.1486946 L0,14 L0.01,2 C0.01,0.95 0.820929752,0.082231405 1.85136551,0.00551277235 L2,0 L7.00922203,0 Z M7.00922203,2 L2.00999931,2.00166667 L2,14 L18,14 L18,4 L10.9970301,4 C9.98506984,4 8.81419501,3.54226902 8.03565409,2.85431634 L7.8750299,2.70345702 L7.29654298,2.1249701 L7.27022108,2.10994272 L7.0847011,2.02870664 L7.00922203,2 Z" id="Shape"></path>
        </g>
    </g>
</svg>
</ng-template>
<ng-template #expandIcon>
  <svg width="24px" height="25px" viewBox="0 0 24 25" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
      <g id="Icon/product/keyboard-arrow-down-new" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
          <path d="M7.25735931,9.79289322 C7.6478836,9.40236893 8.28104858,9.40236893 8.67157288,9.79289322 L12.5,13.6213203 L16.3284271,9.79289322 C16.7189514,9.40236893 17.3521164,9.40236893 17.7426407,9.79289322 C18.133165,10.1834175 18.133165,10.8165825 17.7426407,11.2071068 L12.5,16.4497475 L7.25735931,11.2071068 C6.86683502,10.8165825 6.86683502,10.1834175 7.25735931,9.79289322 Z" id="Path" fill="#8B96A0"></path>
      </g>
  </svg>
</ng-template>
<ng-template #collapseIcon>
  <svg width="24px" height="25px" viewBox="0 0 24 25" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
      <g id="Icon/product/keyboard-arrow-up-new" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
          <path d="M17.7426407,16.1568542 C17.3521164,16.5473785 16.7189514,16.5473785 16.3284271,16.1568542 L12.5,12.3284271 L8.67157288,16.1568542 C8.28104858,16.5473785 7.6478836,16.5473785 7.25735931,16.1568542 C6.86683502,15.76633 6.86683502,15.133165 7.25735931,14.7426407 L12.5,9.5 L17.7426407,14.7426407 C18.133165,15.133165 18.133165,15.76633 17.7426407,16.1568542 Z" id="Path" fill="#8B96A0"></path>
      </g>
  </svg>
</ng-template>